import { GroupType } from '../../shared/models/api/group.model';

export const groupTypeTranslation: Readonly<Record<GroupType, string>> = {
  [GroupType.ROLE]: 'GROUPS.TYPE.ROLE',
  [GroupType.LOCATION]: 'GROUPS.TYPE.LOCATION',
  [GroupType.PRODUCT_TEAM]: 'GROUPS.TYPE.PRODUCT_TEAM',
};
